import React, { useEffect, useState } from "react";
import { useOrder } from "../context/OrderContext";
import { useStepNavigate } from "../hooks/useStepNavigate";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { showErrorToast } from "../components/toasts/ToastService";
import { useOrderSave } from "../context/OrderSaveContext";

const betetTartozekok = [
    { value: "J15", label: "J15" },
    { value: "J10", label: "J10" }
];

const BetetTartozek = () => {
    const { order, updateOrder,} = useOrder();
    const navigate = useStepNavigate();
    const [loading, setLoading] = useState(false);
    const { saveOrder, loading: orderSaveLoading } = useOrderSave();

    const handleSelected = (value) => {
        updateOrder({
            ...order,
            hmeliorder: {
                ...order.hmeliorder,
                hmeliorder_betet_tartozek: value
            }
        });
    };

    const handleBackClick = () => {
        if (order.hmeliorder?.hmeliorder_order_type === 1 && order.hmeliorder?.hmeliorder_specaidtype === 2) {
            navigate('/KozgyogyKerdes');
        } else if (order.hmeliorder?.hmeliorder_order_type === 1 && order.hmeliorder?.hmeliorder_specaidtype === 3) {
            navigate('/UzemiKerdes');
        } else if (order.hmeliorder?.hmeliorder_order_type === 1 && order.hmeliorder?.hmeliorder_specaidtype === 5) {
            navigate('/EgyediKerdes');
        } else if (order.hmeliorder?.hmeliorder_order_type === 1 )  {
            navigate('/AdatVenyes');
        } else if (order.hmeliorder?.hmeliorder_order_type !== 1) {
            navigate('/ProjektValaszto');
        }
    };

    const handleSaveAndNavigate = async () => {
        if (!order.hmeliorder?.hmeliorder_betet_tartozek) {
            showErrorToast("Kérem, válasszon betét tartozékot!");
            return;
        }
        try {
            setLoading(true);
            const updatedOrder = {
                ...order,
                hmeliorder: {
                    ...order.hmeliorder,
                    hmeliorder_betet_tartozek: order.hmeliorder.hmeliorder_betet_tartozek,
                },
            };
            updateOrder(updatedOrder);
            // const result = await saveOrder(updatedOrder);
            // if (result.success) {
            if (order.hmeliorder?.hmeliorder_order_type === 1) {
                navigate("/Mennyiseg");
            } else {
                navigate("/Meretvetel");
            };
            // }
        } catch (error) {
            console.error("Hiba a rendelés mentésekor:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <TablerLayout title="Betét tartozék">
                <div className="row justify-content-center">
                    <div className="col-md-10 mb-4">
                        <div className="card-body text-center">
                            <h5 className="mb-3 text-start">Kérem válassza ki a betét tartozékot:</h5>
                            <div className="row g-4 justify-content-center">
                                {betetTartozekok.map((item) => (
                                    <div className="col-12 col-md-6 d-flex justify-content-center" key={item.value}>
                                        <button
                                            type="button"
                                            className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold ${order.hmeliorder?.hmeliorder_betet_tartozek === item.value ? 'btn-primary' : 'btn-outline-primary'}`}
                                            style={{ fontSize: 22 }}
                                            onClick={() => handleSelected(item.value)}
                                        >
                                            {item.label}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mt-4">
                            <StepperNavButton 
                                side="left"
                                label="Vissza" 
                                onClick={handleBackClick}
                            />
                            <StepperNavButton
                                side="right"
                                label="Tovább"
                                onClick={handleSaveAndNavigate}
                                disabled={loading || !order.hmeliorder?.hmeliorder_betet_tartozek}
                            />
                        </div>
                    </div>
                </div>
            </TablerLayout>
        </>
    );
};

export default BetetTartozek;